import { LifestyleConfirmPageTemplate } from "./template";
import { useLifestyleConfirmPage } from "./logic";

export const LifestyleConfirmPage = () : JSX.Element => {
    const props = useLifestyleConfirmPage();

    return (
        <LifestyleConfirmPageTemplate {...props}/>
    )
} 